import { createActionGroup, props } from '@ngrx/store';
import { Course } from '@lyceo/shared/plan/util-models';

export const CourseActions = createActionGroup({
  source: 'Course API',
  events: {
    'Get All Success': props<{ courses: Course[] }>(),
    'Get All Failure': props<{ error: Error }>(),
  },
});
